var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { buttonClasses } from '@mui/material/Button';
// ----------------------------------------------------------------------
var COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function button(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var _a;
        var inheritColor = ownerState.color === 'inherit';
        var containedVariant = ownerState.variant === 'contained';
        var outlinedVariant = ownerState.variant === 'outlined';
        var textVariant = ownerState.variant === 'text';
        var softVariant = ownerState.variant === 'soft';
        var smallSize = ownerState.size === 'small';
        var mediumSize = ownerState.size === 'medium';
        var largeSize = ownerState.size === 'large';
        var defaultStyle = __assign(__assign({}, (inheritColor && __assign(__assign(__assign(__assign({}, (containedVariant && {
            color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
            backgroundColor: lightMode ? theme.palette.grey[800] : theme.palette.common.white,
            '&:hover': {
                backgroundColor: lightMode ? theme.palette.grey[700] : theme.palette.grey[400]
            }
        })), (outlinedVariant && {
            borderColor: alpha(theme.palette.grey[500], 0.32),
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        })), (textVariant && {
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        })), (softVariant && {
            color: theme.palette.text.primary,
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            '&:hover': {
                backgroundColor: alpha(theme.palette.grey[500], 0.24)
            }
        })))), (outlinedVariant && {
            '&:hover': {
                borderColor: 'currentColor',
                boxShadow: '0 0 0 0.5px currentColor'
            }
        }));
        var colorStyle = COLORS.map(function (color) { return (__assign({}, (ownerState.color === color && __assign(__assign({}, (containedVariant && {
            '&:hover': {
                boxShadow: theme.customShadows[color]
            }
        })), (softVariant && {
            color: theme.palette[color][lightMode ? 'dark' : 'light'],
            backgroundColor: alpha(theme.palette[color].main, 0.08),
            '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.32)
            }
        }))))); });
        var disabledState = (_a = {},
            _a["&.".concat(buttonClasses.disabled)] = __assign({}, (softVariant && {
                backgroundColor: theme.palette.action.disabledBackground
            })),
            _a);
        var size = __assign(__assign(__assign({}, (smallSize && __assign({ height: 30, fontSize: 13, paddingLeft: 8, paddingRight: 8 }, (textVariant && {
            paddingLeft: 4,
            paddingRight: 4
        })))), (mediumSize && __assign({ paddingLeft: 12, paddingRight: 12 }, (textVariant && {
            paddingLeft: 8,
            paddingRight: 8
        })))), (largeSize && __assign({ height: 48, fontSize: 15, paddingLeft: 16, paddingRight: 16 }, (textVariant && {
            paddingLeft: 10,
            paddingRight: 10
        }))));
        return __spreadArray(__spreadArray([defaultStyle], __read(colorStyle), false), [disabledState, size], false);
    };
    return {
        MuiButton: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        }
    };
}
